import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f802d98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Search_Contents" }
const _hoisted_2 = { class: "Search_Contents_Title" }
const _hoisted_3 = { class: "Search_Contents_List" }

import { ref, watch } from "vue";
import InputText from "../atoms/Input/InputText.vue";
import ModalShopList from "../modal/ModalShopList.vue";
import { useStore } from "vuex";
import { Notyf } from "notyf";

interface Props {
  // css調整用----------
  titleMinWidth?: string;
  titleMaxWidth?: string;
  listMinWidth?: string;
  inputNumWidth?: string;
  inputSyotenMeiWidth?: string;
  // -------------------
  parentSyotenData: {
    bansen: string;
    hanmotoCd: string;
    syotenMei: string;
    toritugiCd: string;
    toritugiSyotenCd: string;
    zassiBansen: string;
  };
  title: string;
}
type SyotenData = typeof props.parentSyotenData;

export default /*#__PURE__*/_defineComponent({
  __name: 'searchInputSyoten',
  props: {
    titleMinWidth: {},
    titleMaxWidth: {},
    listMinWidth: {},
    inputNumWidth: {},
    inputSyotenMeiWidth: {},
    parentSyotenData: {},
    title: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "b48a0920": (props.titleMaxWidth !== undefined?props.titleMaxWidth : '90px'),
  "7cb61e68": (props.titleMinWidth !== undefined?props.titleMinWidth : '90px'),
  "d7dcddf2": (props.listMinWidth !== undefined?props.listMinWidth : '224px'),
  "5b2c95d2": (props.inputNumWidth !== undefined?props.inputNumWidth : '30%'),
  "db49866a": (props.inputSyotenMeiWidth !== undefined?props.inputSyotenMeiWidth : '65%')
}))

const store = useStore();
const notyf = new Notyf();

// props
const props = __props;
// emit
const emit = __emit;

const syotenData = ref({} as SyotenData);
// 親データとの連携
watch(
  () => ({ ...props.parentSyotenData }),
  () => {
    syotenData.value = Object.assign({}, props.parentSyotenData);
  },
  { immediate: true, deep: true }
);
// ストアとの連携
watch(
  () => syotenData.value,
  () => {
    store.commit("search/setSyotenDetailState", syotenData.value);
  },
  { immediate: true, deep: true }
);

// モーダル開閉制御
const syotenModalVisible = ref(false);

let holdToritugiSyotenCd = "";
const focusToritugiSyotenCd = (e: string) => {
  holdToritugiSyotenCd = e;
};
const inputToritugiSyotenCd = (e: string) => {
  syotenData.value.toritugiSyotenCd = e;
  console.log(syotenData.value.toritugiSyotenCd);
};
const searchSyoten = async (): Promise<void> => {
  // 入力値が空だったら各値をリセットする
  if (syotenData.value.toritugiSyotenCd === "") {
    syotenData.value.bansen = "";
    syotenData.value.hanmotoCd = "";
    syotenData.value.syotenMei = "";
    syotenData.value.toritugiCd = "";
    syotenData.value.toritugiSyotenCd = "";
    syotenData.value.zassiBansen = "";
    emit("change", syotenData.value);
  } else {
    await store.dispatch("search/searchToritugiSyotenCd");
    const res = store.getters["search/getSyotenData"];
    if (res.syotenToritugiList.length > 0) {
      ref_selectSyoten(res.syotenToritugiList[0]);
    } else {
      console.log(holdToritugiSyotenCd);
      //該当する書店が無ければ以前の状態に戻す
      syotenData.value.toritugiSyotenCd = holdToritugiSyotenCd;
      notyf.error("該当する書店がありません");
    }
  }
};
//書店選択を反映
const ref_selectSyoten = (selectedValue: SyotenData): void => {
  syotenData.value.bansen = selectedValue.bansen;
  syotenData.value.hanmotoCd = selectedValue.hanmotoCd;
  syotenData.value.syotenMei = selectedValue.syotenMei;
  syotenData.value.toritugiCd = selectedValue.toritugiCd;
  syotenData.value.toritugiSyotenCd = selectedValue.toritugiSyotenCd;
  syotenData.value.zassiBansen = selectedValue.zassiBansen;
  emit("change", syotenData.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (syotenModalVisible.value)
      ? (_openBlock(), _createBlock(ModalShopList, {
          key: 0,
          toritugiCd: syotenData.value.toritugiCd,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (syotenModalVisible.value = false)),
          onRef_selectSyoten: ref_selectSyoten
        }, null, 8, ["toritugiCd"]))
      : _createCommentVNode("", true),
    _createElementVNode("li", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(InputText, {
          class: "Input_Yellow",
          onDblclick: _cache[1] || (_cache[1] = ($event: any) => (syotenModalVisible.value = true)),
          value: syotenData.value.toritugiSyotenCd,
          type: 'text',
          onOnFocus: focusToritugiSyotenCd,
          onOnInput: inputToritugiSyotenCd,
          onOnChange: searchSyoten,
          onkeydown: "return event.keyCode !== 69"
        }, null, 8, ["value"]),
        _createVNode(InputText, {
          class: "Input_Gray",
          value: syotenData.value.syotenMei
        }, null, 8, ["value"])
      ])
    ])
  ], 64))
}
}

})